import { render, staticRenderFns } from "./CtrlShogTekiyo.vue?vue&type=template&id=4b700b19&scoped=true&"
import script from "./CtrlShogTekiyo.vue?vue&type=script&lang=ts&"
export * from "./CtrlShogTekiyo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b700b19",
  null
  
)

export default component.exports